import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Button, Image } from '@outdoor-voices/ui';
import cc from 'classcat';
import PropTypes from 'prop-types';
import css from './GiftsForMobile.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var GiftsForMobile = function GiftsForMobile(_ref) {
  var image = _ref.image,
      _ref$padded = _ref.padded,
      padded = _ref$padded === void 0 ? false : _ref$padded,
      title = _ref.title,
      url = _ref.url,
      cta = _ref.cta;
  return /*#__PURE__*/_jsxs("div", {
    className: cc([css.root, _defineProperty({}, css.padded, padded)]),
    children: [/*#__PURE__*/_jsx(Image, _objectSpread({}, image)), /*#__PURE__*/_jsxs("div", {
      className: css.text,
      children: [/*#__PURE__*/_jsx("h2", {
        className: css.title,
        children: title
      }), /*#__PURE__*/_jsx("div", {
        className: css.button,
        children: /*#__PURE__*/_jsx(Button, {
          big: true,
          href: url,
          white: true,
          children: /*#__PURE__*/_jsx("span", {
            dangerouslySetInnerHTML: {
              __html: cta
            }
          })
        })
      })]
    })]
  });
};

GiftsForMobile.propTypes = {
  padded: PropTypes.bool,
  title: PropTypes.string,
  url: PropTypes.string,
  cta: PropTypes.string,
  image: PropTypes.shape({})
};
export default GiftsForMobile;